import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1>Error 404 not found!</h1>
        </div>
    );
};

export default NotFound;